// extracted by mini-css-extract-plugin
export var width100 = "L_w d_w";
export var design3Pos = "L_xv d_0";